import { FC } from 'react';
import { Agent } from 'src/types/agents.ts';
import { OpacityBox } from 'src/components/UI/OpacityBox.tsx';
import { NavLink } from 'react-router-dom';
import { UIButton } from 'src/components/UI/UIButton.tsx';
import { Icon } from '@iconify/react';

interface AgentBannerProps {
  agent: Agent;
}

export const AgentBanner: FC<AgentBannerProps> = ({ agent }) => {
  return (
    <div className="w-full">
      <OpacityBox
        style={{
          backgroundImage: "url('/images/ai-marketplace/agent-banner.png')",
        }}
        className="relative flex min-h-[254px] flex-col items-center justify-between overflow-hidden border border-white border-opacity-10 bg-cover bg-right bg-no-repeat sm:flex-row sm:items-start"
      >
        <div className="flex h-full w-full max-w-[400px] flex-col-reverse items-center gap-3 p-4 sm:flex-col sm:items-start md:p-6 lg:p-8">
          <h2 className="mb-1 text-2xl leading-none md:text-3xl lg:text-4xl xl:text-5xl">
            {agent.name}
          </h2>
          <p className="font-normal opacity-40">{agent.description}</p>
          <NavLink to="/build-ai-agent">
            <UIButton className="mt-auto" size="xl" buttonColor="blue">
              Create Your Agent
              <Icon icon="fa6-solid:circle-arrow-right" className="ml-1" />
            </UIButton>
          </NavLink>
        </div>
        <div className="mr-4 h-40 w-40 overflow-hidden rounded-[30px] md:mr-6 md:h-48 md:w-48 lg:mr-8 lg:h-56 lg:w-56">
          <img src={agent.image_url} className="h-full w-full object-cover" />
        </div>
      </OpacityBox>
    </div>
  );
};
